import { Brands } from '../../../config/brands';
import mainTheme from '../theme';

const theme = {
  ...mainTheme,
  name: Brands.CETETHERM,
  COLORS: {
    ...mainTheme.COLORS,
    primary: '#71B750',
    secondary: '#1A2737',
  },
};

export default theme;
